import styled from '@emotion/styled';

export const SettingsNote = styled.div`
    margin-left: 0.5rem;
    padding: 0.25rem 0.5rem;
    border-left: 2px solid ${(props) => props.theme.color.cardHover};
    gap: 0.5rem;
`;

export const SettingsButtonContainer = styled.div`
    min-width: 150px;
`;
